document.addEventListener('DOMContentLoaded', function () {
  initCustomImageSliders(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initCustomImageSliders(event.target);
});

function initCustomImageSliders(context) {
  const containers = context.querySelectorAll(
    '.product-slider.product-slider--custom-images .product-slider__swiper'
  );

  containers.forEach(function (container) {
    if (container.classList.contains('swiper-initialized')) return;

    const paginationEl = container.querySelector(
      '.swiper-pagination.product-slider__swiper-pagination'
    );

    new Swiper(container, {
      loop: false,
      spaceBetween: 6,
      slidesPerView: 1.225,
      pagination: {
        el: paginationEl,
        type: 'progressbar',
      },
      grabCursor: true,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      watchOverflow: true,
      breakpoints: {
        500: {
          loop: false,
          slidesPerView: 1.45,
          centeredSlides: false,
          spaceBetween: 6,
        },
        600: {
          loop: false,
          slidesPerView: 1.8,
          centeredSlides: false,
          spaceBetween: 8,
        },
        800: {
          loop: false,
          slidesPerView: 2.2,
          centeredSlides: false,
          spaceBetween: 8,
        },
        900: {
          loop: false,
          slidesPerView: 2.6233,
          centeredSlides: false,
          spaceBetween: 8,
        },
      },
    });
  });
}